import React from 'react';
import {Link} from 'react-router-dom';
export default class ErrorPage extends React.Component {
  componentDidMount () {
    var element = document.createElement('link');
    element.setAttribute('rel', 'stylesheet');
    element.setAttribute('type', 'text/css');
    element.setAttribute('href', 'https://cdnjs.cloudflare.com/ajax/libs/twitter-bootstrap/3.3.6/css/bootstrap.min.css');
    document.getElementsByTagName('head')[0].appendChild(element);
    var root = document.getElementsByTagName('html')[0]; // '0' to assign the first (and only `HTML` tag)

    root.setAttribute('class', 'studio-scss');
  }

  componentWillUnmount () {
    const root = document.getElementsByTagName('html')[0]; // '0' to assign the first (and only `HTML` tag)
    root.removeAttribute('class', 'studio-scss');
    document.querySelectorAll('[href="https://cdnjs.cloudflare.com/ajax/libs/twitter-bootstrap/3.3.6/css/bootstrap.min.css"]').forEach(e => e.parentNode.removeChild(e));
  }

  render () {
    const fourOhFour = true; // When would we ever show a maintenance page?
    return (
      <div className='error-page'>
        <div className='header'>
          <img
            className='logo-404'
            src={require('static/images/modsy-mobile-logo.png')}
            alt=''
          />
        </div>
        {fourOhFour ? (
          <div className='content'>
            <img src={require('static/images/white-overlay.png')} className='overlay' alt='' />
            <div className='inner-content'>
              <div className='info'>
                <span className='oh-no'>OH, WOW!</span>
                <h3>404 Error</h3>
                <p className='explanation'>
                  We were unable to render this page due to some missing pixels.
                  Let's give this another try!
                </p>
                <span className='refresh'>
                  Refresh the page or check your url is entered correctly.
                </span>
                <Link to='/' className='return-but'>
                  Return Home
                </Link>
              </div>
            </div>
            <div className='couch'>
              <img src={require('static/images/pixelated-sofa.png')} alt='' />
            </div>
          </div>
        ) : (
          <div className='content'>
            <img
              style={{ minHeight: '0' }}
              src={require('static/images/white-overlay.png')}
              className='overlay'
              alt=''
            />
            <div className='maintenance'>
              <span className='top-head'>MAINTENANCE</span>
              <h3>We’ll be back shortly.</h3>
              <p>
                We’re busy updating the website for you and will be back soon.
              </p>
              <img src={require('static/images/heart-icon.svg')} alt='' />
              <span className='team'>Modsy Team</span>
            </div>
          </div>
        )}
      </div>
    );
  }
}
